const paymentConfig = {
  preferred_bank_for_payments: "Banco preferido para pagos",
  payment_configurations: "Configuración de pagos",
  bill_creation_email:
    "Enviar correo electrónico cuando se cree una nueva factura",
  due_invoice_email:
    "Enviar correo recordatorio cuando una factura esté vencida (diario)",
  configuration_updated_successfully: "Configuración actualizada con éxito",
};

export default paymentConfig;
